import storage from '../global-utils/Storage'
import * as settings from './UserSettingsActions'

export default (state = settings.getInitialState(), action = {}) => {
  switch (action.type) {
    case settings.USER_CODE_RENEW: {
      return { ...state, error: undefined, generatingCode: true }
    }
    case settings.USER_CODE_RENEW_CANCELED: {
      return { ...state, generatingCode: false }
    }
    case settings.USER_CODE_RENEW_ERROR: {
      return { ...state, error: action.payload, generatingCode: false }
    }
    case settings.USER_CODE_RENEW_FULFILLED: {
      return { ...state, generatingCode: false }
    }

    case settings.USER_SETTINGS_AVATAR_ADD: {
      return state
    }
    case settings.USER_SETTINGS_AVATAR_ADD_CANCELED: {
      return state
    }
    case settings.USER_SETTINGS_AVATAR_ADD_ERROR: {
      return { ...state, error: action.payload }
    }
    case settings.USER_SETTINGS_AVATAR_ADD_FULFILLED: {
      return {
        ...state,
        data: [
          {
            ...state.data[0],
            ...action.payload.data[0],
          },
        ],
      }
    }

    case settings.USER_SETTINGS_BANNER_ADD: {
      return state
    }
    case settings.USER_SETTINGS_BANNER_ADD_CANCELED: {
      return state
    }
    case settings.USER_SETTINGS_BANNER_ADD_ERROR: {
      return { ...state, error: action.payload }
    }
    case settings.USER_SETTINGS_BANNER_ADD_FULFILLED: {
      const newState = { ...state }
      newState.data[0].picture = action.payload.data[0] || {}
      return newState
    }

    case settings.USER_SETTINGS_FETCH: {
      return { ...state, error: undefined, loaded: false, loading: true }
    }
    case settings.USER_SETTINGS_FETCH_CANCELED: {
      return { ...state, loaded: false, loading: false }
    }
    case settings.USER_SETTINGS_FETCH_ERROR: {
      return { ...state, ...action.payload, loaded: false, loading: false }
    }
    case settings.USER_SETTINGS_FETCH_FULFILLED: {
      return { ...state, ...action.payload, loaded: true, loading: false }
    }

    case settings.USER_SETTINGS_UPDATE: {
      return { ...state, error: undefined }
    }
    case settings.USER_SETTINGS_UPDATE_CANCELED: {
      return state
    }
    case settings.USER_SETTINGS_UPDATE_ERROR: {
      return { ...state, error: action.payload }
    }
    case settings.USER_SETTINGS_UPDATE_FULFILLED: {
      if (action.payload.originalAction.payload.settings.deleteAccount) {
        storage.clear()
        document.location.href = '/'
      }
      return { ...state, ...action.payload }
    }
    default:
  }
  return state
}
